import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class TypesenseService {

    public baseUrl = (environment as any).typesense;

    constructor(
        public auth: AuthService,
        private http: HttpClient,
    ) {
    }

    searchDocuments(collection: string, query_by: string, query: string, filter: string = '') {

        let filtered = `account_key:=${this.auth.account}`;

        // solo agregar si el filtro no está vacío y no rompe el formato
        if (filter && !filter.trim().startsWith('account_key:=')) {
            filtered += ` && ${filter.trim()}`;
        }

        const params = new HttpParams()
            .set('collection', collection)
            .set('q', query)
            .set('query_by', query_by)
            .set('filter_by', `account_key:=${this.auth.account}`);

        return this.http.get<any>(`${this.baseUrl}/search`, { params }).pipe(
            map((res) => ({
                found: res.found,
                page: res.page,
                total_pages: res.total_pages,
                documents: res.hits.map((element: any) => ({
                    ...element.document,
                    $key: element.document.id,
                }))
            }))
        );

    }
}
